var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatNavigationBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 319,
    height: 868,
    viewBox: "0 0 319 868",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_39_115",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 319,
    height: 868
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M319 0H0V867.86H319V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_39_115)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M319 0H0V867.9H319V0Z",
    fill: "#00426B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M481.703 586.216L-37.5043 1105.42L74.1549 1217.08L593.362 697.875L481.703 586.216Z",
    fill: "url(#paint0_linear_39_115)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3339 614.783L-260.714 961.831L-197.718 1024.83L149.33 677.78L86.3339 614.783Z",
    fill: "url(#paint1_linear_39_115)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M292.38 651.738L-410.024 1354.14L-383.197 1380.97L319.208 678.566L292.38 651.738Z",
    fill: "url(#paint2_linear_39_115)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M319.01 0H0.0100098V867.01H319.01V0Z",
    fill: "#00426B"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M183.94 872.66L188.65 879.3L264.9 803.04H253.55L183.94 872.66Z",
    fill: "url(#paint3_linear_39_115)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_39_115",
    x1: 174.484,
    y1: 1046.33,
    x2: 195.803,
    y2: 631.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ACC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#008CA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#006C8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#00547A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#00466F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00426B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_39_115",
    x1: -198.154,
    y1: 819.807,
    x2: 51.3261,
    y2: 819.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ACC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00426B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_39_115",
    x1: -45.4016,
    y1: 1279.85,
    x2: -45.402,
    y2: 767.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ACC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00426B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_39_115",
    x1: 171.26,
    y1: 841.17,
    x2: 263.76,
    y2: 841.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6871F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC4B28"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatNavigationBackground);
export default __webpack_public_path__ + "static/media/Chat-Navigation-Background.9be886b64d867d756072a916f240bec8.svg";
export { ForwardRef as ReactComponent };